import React from 'react';
import { motion } from 'framer-motion';
import { 
  Mail, 
  Phone, 
  MapPin, 
  Linkedin, 
  Twitter, 
  Github,
  ArrowUp
} from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      'Fintech Solutions',
      'ERP Systems',
      'Supply Chain Management',
      'SDLC Solutions',
      'Cloud Services',
      'AI & Machine Learning'
    ],
    company: [
      'About Us',
      'Our Team',
      'Careers',
      'Case Studies',
      'News & Updates',
      'Privacy Policy'
    ],
    support: [
      'Contact Support',
      'Documentation',
      'Training',
      'Community',
      'FAQ',
      'Terms of Service'
    ]
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div 
            className="footer-main"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="footer-brand">
              <h3>Noonic Solutions</h3>
              <p>
                Empowering businesses with innovative software solutions and expert IT manpower. 
                Your trusted partner in digital transformation.
              </p>
              
              <div className="footer-contact">
                <div className="contact-item">
                  <Mail size={16} />
                  <span>info@abcsolutions.com</span>
                </div>
                <div className="contact-item">
                  <Phone size={16} />
                  <span>+1 (555) 123-4567</span>
                </div>
                <div className="contact-item">
                  <MapPin size={16} />
                  <span>Corrazone Coworking Space, Kochi, Kerala 682022</span>
                </div>
              </div>
              
              <div className="social-links">
                <a href="#" aria-label="LinkedIn">
                  <Linkedin size={20} />
                </a>
                <a href="#" aria-label="Twitter">
                  <Twitter size={20} />
                </a>
                <a href="#" aria-label="GitHub">
                  <Github size={20} />
                </a>
              </div>
            </div>
            
            <div className="footer-links">
              <div className="link-group">
                <h4>Services</h4>
                <ul>
                  {footerLinks.services.map((link, index) => (
                    <li key={index}>
                      <a href="#">{link}</a>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="link-group">
                <h4>Company</h4>
                <ul>
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <a href="#">{link}</a>
                    </li>
                  ))}
                </ul>
              </div>
              
              <div className="link-group">
                <h4>Support</h4>
                <ul>
                  {footerLinks.support.map((link, index) => (
                    <li key={index}>
                      <a href="#">{link}</a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </motion.div>
          
          <motion.div 
            className="footer-newsletter"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4>Stay Updated</h4>
            <p>Subscribe to our newsletter for the latest updates and insights.</p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address"
                aria-label="Email address"
              />
              <button type="submit" className="btn btn-primary">
                Subscribe
              </button>
            </div>
          </motion.div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} Noonic Solutions. All rights reserved.</p>
            <p>Designed and developed with ❤️ for innovation</p>
          </div>
          
          <button 
            className="scroll-to-top"
            onClick={scrollToTop}
            aria-label="Scroll to top"
          >
            <ArrowUp size={20} />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
